import React, { useEffect, useState } from 'react';
import { getAllBlogs } from "../../services/getAllApi";
import "../../styles/blogs.css";

const Blogs = () => {
  const [blogsData, setBlogsData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getAllBlogs();
        if (response.status === 200 && Array.isArray(response.data)) {
          setBlogsData(response.data);
        } else {
          setBlogsData([]);
        }
      } catch (error) {
        console.error("Error fetching blogs:", error);
        setBlogsData([]);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="blogs-container">
      <h2 className="blogs-heading">Our Latest Blogs</h2>
      <div className="blogs-scroll">
        {blogsData.map((blog) => (
          <a
            href={blog.link}
            target="_blank"
            rel="noopener noreferrer"
            className="blog-link"
            key={blog.id}
          >
            <div className="blog-card">
              <img
                src={`${"https://console.fbsedu.in/storage/app/"}/public/${blog.blog_image}`}
                alt={blog.title}
                className="blog-image"
              />
              <h3 className="blog-title">{blog.title}</h3>
              {/* 🌟 Add the Published Date Here */}
              {blog.date && (
                <p className="blog-date">
                  Published on: {new Date(blog.date).toLocaleDateString()}
                </p>
              )}
              <p className="blog-description">{blog.description}</p>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default Blogs;
